<template>
  <div class="interface">
    <SelectServer ref="SelectServer" v-on:selectServerComplete="selectServerComplete"></SelectServer>
    <Row :gutter="16">
      <Col :lg="6" style="padding: 5px">
        <Card :padding="0" shadow>
          <div slot="title" style="font-weight: bold;">
            <Icon type="ios-options"></Icon>
            <span> 设置</span>
          </div>
          <CellGroup style="padding: 5px 0;" @on-click="cellClick">
            <Cell title="首页" name="home" extra="〉" :selected="cell === 'home'" />
            <Cell title="监控" name="monitor" extra="〉" :selected="cell === 'monitor'" />
          </CellGroup>
        </Card>
      </Col>
      <Col :lg="18" style="padding: 5px" class="split-line-left">
        <Card v-show="cell === 'home'">
          <div slot="title" style="font-weight: bold;">首页配置</div>
          <div class="config-item">
            <div style="padding-bottom: 15px; border-bottom: 1px solid rgba(232, 234, 236,0.5);">
              <div class="config-item-title">主题设置</div>
              <RadioGroup :value="themeCurrent" @on-change="themeHandle" class="theme-div">
                <Radio label="themeOne">主题一<img src="../../assets/images/theme-one.png"></Radio>
                <Radio label="themeTwo">主题二<img src="../../assets/images/theme-two.png"></Radio>
                <Radio label="themeThree">主题三<img src="../../assets/images/theme-three.png"></Radio>
                <Radio label="themeFour">主题四<img src="../../assets/images/theme-four.png"></Radio>
                <Radio label="themeFive">主题五<img src="../../assets/images/theme-five.png"></Radio>
                <Radio label="themeSix">主题六<img src="../../assets/images/theme-six.png"></Radio>
              </RadioGroup>
            </div>
          </div>
          <div class="config-item">
            <div style="padding-bottom: 15px; border-bottom: 1px solid rgba(232, 234, 236,0.5)">
              <div class="config-item-title">首页页面</div>
              <div class="config-item-content">
                <RadioGroup v-model="homeConfigForm.homePage">
                  <Radio label="worksheet">工单 DashBoard</Radio>
                  <Radio label="monitor">监控 & 主机概览</Radio>
                  <Radio label="reports">统计报表</Radio>
                </RadioGroup>
              </div>
            </div>
          </div>
          <div class="config-item" v-if="homeConfigForm.homePage === 'monitor'">
            <div style="padding-bottom: 15px; border-bottom: 1px solid rgba(232, 234, 236,0.5)">
              <div class="config-item-title">展示内容</div>
              <div class="config-item-content">
                <Checkbox-group v-model="homeConfigForm.homeModule">
                  <Checkbox :label="item.component" v-for="item in homeModuleList" :key="item.component">{{ item.name }}</Checkbox>
                </Checkbox-group>
              </div>
            </div>
            <div style="padding-bottom: 15px;">
              <div class="config-item-title">监控概览默认显示主机</div>
              <div class="config-item-content">
                <Button type="default" @click="openSelectServerModal" icon="ios-desktop-outline" size="small">
                  <span v-if="homeConfigForm.homeMonitorOverviewDefaultEndpoint">{{ homeConfigForm.homeMonitorOverviewDefaultEndpoint }}</span>
                  <span v-else>请选择</span>
                </Button>
              </div>
            </div>
          </div>
          <div style="text-align: right; padding-top: 10px">
            <Button type="primary" :loading="saving" @click="saveHomeConfigData">保存</Button>
          </div>
        </Card>
        <Card v-show="cell === 'monitor'">
          <div slot="title" style="font-weight: bold; color: #000;">监控配置</div>
          <div style="padding-bottom: 15px;">
            <div class="config-item-title">监控图主题</div>
            <div class="config-item-content">
              <Select v-model="monitorConfigForm.theme" style="width:200px;">
                <Option v-for="item in themeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </div>
          </div>
          <div style="text-align: right; padding-top: 10px">
            <Button type="primary" :loading="saving" @click="saveMonitorConfig">保存</Button>
          </div>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import { getHomeConfig, postHomeConfig } from '@/api/settings'
import { getMonitorConfig, changeMonitorConfig } from '@/api/monitor'
import SelectServer from '@/view/ops-center/select-server'
const theme = localStorage.getItem('theme') || 'themeOne'
export default {
  name: 'interface',
  components: {
    SelectServer
  },
  data () {
    return {
      themeCurrent: theme,
      cell: '',
      homeModuleList: [
        { component: 'ciCdUpcoming', name: '持续交付待办' },
        { component: 'alarmList', name: '正在告警列表' },
        { component: 'serverCount', name: '主机概览' },
        { component: 'alarmCount', name: '告警概览' },
        { component: 'MonitorOverview', name: '监控概览' },
        { component: 'MonitorBoard', name: '监控大盘' }
      ],
      homeConfigForm: {
        homePage: 'worksheet',
        homeModule: [],
        homeMonitorOverviewDefaultEndpoint: ''
      },
      themeList: [
        {label: 'dark', value: 'dark'},
        {label: 'roma', value: 'roma'},
        {label: 'shine', value: 'shine'},
        {label: 'vintage', value: 'vintage'},
        {label: 'macarons', value: 'macarons'},
        {label: 'infographic', value: 'infographic'},
        {label: 'darkPro', value: 'darkPro'},
        {label: 'dark-line', value: 'dark-line'},
        {label: 'roma-line', value: 'roma-line'},
        {label: 'shine-line', value: 'shine-line'},
        {label: 'vintage-line', value: 'vintage-line'},
        {label: 'macarons-line', value: 'macarons-line'},
        {label: 'infographic-line', value: 'infographic-line'},
        {label: 'darkPro-line', value: 'darkPro-line'}
      ],
      monitorConfigForm: {
        theme: ''
      },
      saving: false
    }
  },
  created: function () {
    this.cellClick('home')
  },
  methods: {
    themeHandle (theme) {
      document.querySelector('body').className = theme
      // 存储到本地
      localStorage.setItem('theme', theme)
    },
    // 点击菜单触发
    cellClick (name) {
      switch (name) {
        case 'home':
          this.getHomeConfigData()
          break
        case 'monitor':
          this.getMonitorTheme()
          break
      }
      this.cell = name
    },
    // 获取首页配置
    getHomeConfigData () {
      getHomeConfig().then(res => {
        let result = res.data
        let keys = []
        if (result.homeModule) {
          for (let component in result.homeModule) {
            if (result.homeModule.hasOwnProperty(component)) {
              if (result.homeModule[component]) {
                keys.push(component)
              }
            }
          }
        } else {
          for (let i in this.homeModuleList) {
            keys.push(this.homeModuleList[i].component)
          }
        }
        this.homeConfigForm.homeModule = keys
        if (result.homeMonitorOverviewDefaultEndpoint) {
          this.homeConfigForm.homeMonitorOverviewDefaultEndpoint = result.homeMonitorOverviewDefaultEndpoint
        }
        if (result.homePage) {
          this.homeConfigForm.homePage = result.homePage
        }
      })
    },
    // 保存首页配置
    saveHomeConfigData () {
      let reqData = {
        data: {
          homePage: this.homeConfigForm.homePage,
          homeModule: {},
          homeMonitorOverviewDefaultEndpoint: this.homeConfigForm.homeMonitorOverviewDefaultEndpoint
        }
      }
      for (let i in this.homeModuleList) {
        const module = this.homeModuleList[i].component
        reqData.data.homeModule[module] = this.homeConfigForm.homeModule.indexOf(module) > -1
      }
      this.saving = true
      postHomeConfig(reqData).then(res => {
        this.$Notice.success({
          title: '保存成功'
        })
        this.saving = false
      }).catch(err0 => {
        this.saving = false
        if (err0.request) {
          this.$Notice.error({
            title: err0.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '保存失败'
          })
        }
      })
    },
    // 打开服务器选择Modal
    openSelectServerModal () {
      this.$refs.SelectServer.openSelectServerModal({}, {}, '', true)
    },
    // 选择服务器完成回调
    selectServerComplete (server) {
      if (Object.keys(server).length) {
        this.homeConfigForm.homeMonitorOverviewDefaultEndpoint = Object.keys(server)[0]
      } else {
        this.homeConfigForm.homeMonitorOverviewDefaultEndpoint = ''
      }
    },
    // 获取监控主题
    getMonitorTheme () {
      getMonitorConfig().then(res => {
        let result = res.data
        if (result.code === 200) {
          this.monitorConfigForm.theme = result.data.theme
        }
      })
    },
    // 保存监控配置
    saveMonitorConfig () {
      let reqData = {'theme': this.monitorConfigForm.theme}
      this.saving = true
      changeMonitorConfig(reqData).then(res => {
        let result = res.data
        if (result.code === 200) {
          this.$Notice.success({
            title: '保存成功'
          })
          this.saving = false
        }
      })
    }
  }

}
</script>

<style scoped>
  .config-item-title {
    margin: 10px 0;
  }
</style>
<style lang="less">
  .theme-div img{
    width:100px;
    display: block;
    margin-top:5px;
  }
</style>
